import { FormState } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { RadioInput } from 'ui'
import { applyOnStatusValues } from './constants'
import { messages } from './messages'

type Props = {
  name: string
  state: FormState
}

export function ApplyLoyaltyOnStatus(props: Props) {
  const { name, state } = props

  const { $t } = useIntl()

  return (
    <RadioInput
      name={name}
      form={state}
      values={applyOnStatusValues}
      label={$t(messages.label)}
    />
  )
}
